import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../../assets/css/SlimSlider.css';

function Slider3Image() {
    const settings = {
        dots: true, // Display dots for navigation
        infinite: true, // Loop the slider
        speed: 500, // Transition speed in milliseconds
        slidesToShow: 3, // Number of slides to show at once
        slidesToScroll: 1, // Number of slides to scroll
        autoplay: true, // Autoplay the slider
        autoplaySpeed: 3000, // Autoplay speed in milliseconds
        className: "slides"
    };

    return (
        <div className="fullscreen-slider">

        <Slider  {...settings}>
            <div className="fullscreen-slide">
                <img src="/images/bime/1.png" className={'m-auto'} alt="Slide 1" />
                <img src="/images/bime/2.png" className={'m-auto'} alt="Slide 1" />
            </div>
            <div className="fullscreen-slide">
                <img src="/images/bime/3.png" className={'m-auto'} alt="Slide 1" />
                <img src="/images/bime/4.png" className={'m-auto'} alt="Slide 1" />
            </div>
            <div className="fullscreen-slide">
                <img src="/images/bime/5.png" className={'m-auto'} alt="Slide 1" />
                <img src="/images/bime/6.png" className={'m-auto'} alt="Slide 1" />
            </div>
            <div className="fullscreen-slide">
                <img src="/images/bime/7.png" className={'m-auto'} alt="Slide 1" />
                <img src="/images/bime/8.png" className={'m-auto'} alt="Slide 1" />
            </div>
            <div className="fullscreen-slide">
                <img src="/images/bime/9.png" className={'m-auto'} alt="Slide 1" />
                <img src="/images/bime/10.png" className={'m-auto'} alt="Slide 1" />
            </div>
            <div className="fullscreen-slide">
                <img src="/images/bime/11.png" className={'m-auto'} alt="Slide 1" />
                <img src="/images/bime/13.png" className={'m-auto'} alt="Slide 1" />
            </div>
            {/* Add more slides as needed */}
        </Slider>
        </div>
    );
}

export default Slider3Image;